import globalStore from 'store'

const KEY_PREFIX = 'superAdminMode.'

export interface SuperAdminContext {
  enabled: boolean
  companyId?: string
  companyName?: string
}

export const getSuperAdminContext = (): SuperAdminContext => ({
  enabled: sessionStorage.getItem(`${KEY_PREFIX}enabled`) === 'true',
  companyId: sessionStorage.getItem(`${KEY_PREFIX}companyId`) || undefined,
  companyName: sessionStorage.getItem(`${KEY_PREFIX}companyName`) || undefined,
})

export const resolveActiveCompanyId = (): string => {
  const { user } = globalStore.getState()
  const companyId = user?.companyId || ''

  const { enabled, companyId: superCompanyId } = getSuperAdminContext()
  return enabled && superCompanyId ? superCompanyId : companyId
}
